import React, { FC, useCallback, useState } from 'react';
import { IonPage, useIonViewDidEnter, useIonViewDidLeave } from '@ionic/react';
import { AppHeader_v2 as AppHeader, IconArrowLeft, ScreenInputFormFeature } from '@mindly/ui-components';
import { RouteComponentProps } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserPersonalData } from '../../../api/user';
import { setUser } from '../../../redux/user/reducer';
import { userSelector } from '../../../redux/user/selector';
import useToast from '../../../context/ToastContext/ToastContext';
import { useUpdateProfile } from '../../../shared/hooks/useUpdateProfile';
import { useIsKeyBoardShown } from '../../../shared';

const ProfileTaxId: FC<RouteComponentProps> = ({ history }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isFocus, setIsFocus] = useState(false);

  const user = useSelector(userSelector);
  const { showToast } = useToast();
  const dispatch = useDispatch();
  const { successfullyUpdatedProfile } = useUpdateProfile();
  const isKeyboardShown = useIsKeyBoardShown();

  useIonViewDidEnter(() => {
    setIsFocus(true);
  });

  useIonViewDidLeave(() => {
    setIsFocus(false);
  });

  const { t } = useTranslation('profile');

  const handleSubmit = useCallback(async (value: string) => {
    try {
      setIsLoading(true);
      const { data, error, message } = await updateUserPersonalData({
        tax_id: value,
      });

      if (error) {
        throw new Error(message ? t(message) : 'Something went wrong');
      }

      dispatch(setUser(data));
      successfullyUpdatedProfile(true);
    } catch (e: any) {
      showToast({ message: e?.message });
    } finally {
      setIsLoading(false);
    }
  }, []);

  return (
    <IonPage>
      <AppHeader className="flex flex-row items-start cursor-pointer">
        <IconArrowLeft onClick={() => history.back()} />
      </AppHeader>
      <ScreenInputFormFeature
        title={t('personal_details.tax_id.subtitle')}
        subtitle={t('personal_details.date_of_birth.description')}
        placeholder={t('ХХХХХХХХХХ')}
        isLoading={isLoading}
        onSubmit={(value) => handleSubmit(value)}
        buttonText={t('save_button')}
        defaultValue={user?.tax_id ?? ''}
        isFocus={isFocus}
        isKeyboardShown={isKeyboardShown}
      />
    </IonPage>
  );
};

export default ProfileTaxId;
